import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { Sparkle } from "@phosphor-icons/react";

export default function DancerLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [phone, setPhone] = useState("");
  const [pwd, setPwd] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(phone, pwd);
      if (u.role !== "dancer") {
        toast.error("Accès réservé aux danseuses");
        setBusy(false);
        return;
      }
      toast.success(`Bienvenue ${u.full_name}`);
      nav("/portail");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Identifiants invalides", {
        duration: 8000,
      });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-6"
      style={{ background: "#09090b" }}
    >
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ background: "#fbbf24" }}>
            <Sparkle size={24} weight="fill" color="#09090b" />
          </div>
          <div className="text-center">
            <div className="font-display text-2xl font-medium">Gestion Tantra</div>
            <div className="label-xs">Espace Danseuse</div>
          </div>
        </div>

        <div
          className="surface p-8"
          style={{
            background:
              "linear-gradient(180deg, rgba(251,191,36,0.04) 0%, rgba(18,18,23,1) 100%)",
          }}
        >
          <h1 className="font-display text-2xl md:text-3xl font-light tracking-tight mb-2">
            Bienvenue
          </h1>
          <p className="text-sm text-[#a1a1aa] mb-6">
            Connectez-vous pour voir vos comptes, votre solde et vos demandes de règlement.
          </p>

          <form onSubmit={submit} className="space-y-4" data-testid="dancer-login-form">
            <div>
              <Label className="label-xs mb-2 block">Téléphone</Label>
              <Input
                data-testid="dancer-phone"
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="+596 ..."
                className="bg-[#09090b] border-[#27272a] text-white h-12 text-base focus:ring-[#fbbf24]/50 focus:border-[#fbbf24]"
                required
                autoComplete="tel"
              />
            </div>
            <div>
              <Label className="label-xs mb-2 block">Mot de passe</Label>
              <Input
                data-testid="dancer-password"
                type="password"
                value={pwd}
                onChange={(e) => setPwd(e.target.value)}
                placeholder="••••••••"
                className="bg-[#09090b] border-[#27272a] text-white h-12 text-base focus:ring-[#fbbf24]/50 focus:border-[#fbbf24]"
                required
                autoComplete="current-password"
              />
            </div>
            <Button
              data-testid="dancer-login-submit"
              type="submit"
              disabled={busy}
              className="w-full h-12 bg-[#fbbf24] hover:bg-[#f59e0b] text-black font-semibold text-base"
            >
              {busy ? "Connexion..." : "Me connecter"}
            </Button>
          </form>

          <div className="text-xs text-[#71717a] mt-6 text-center">
            Mot de passe par défaut à la création : <b className="text-[#a1a1aa]">Tantra2026</b>
            <br />
            Il vous sera demandé de le changer à la première connexion.
          </div>
        </div>

        <button
          data-testid="back-to-admin"
          onClick={() => nav("/login")}
          className="mt-6 w-full text-xs text-[#71717a] hover:text-[#fbbf24] transition-colors"
        >
          ← Accès back-office
        </button>
      </div>
    </div>
  );
}
